import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAdminNotifications } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canEditOtherUserNotificationSettings } from "@/helpers/permissions";
import { canEditOwnNotificationSettings } from "@/modules/admin-notifications/permissions";

import { adminNotificationsRoutes } from "./routes";

export const adminNotificationsRoute = [
  {
    path: adminNotificationsRoutes.list,
    lazy: async () => {
      const { AdminNotificationsPage } = await import("./pages/list/AdminNotificationsPage");

      return {
        element: (
          <RequireAuth permission={canAccessAdminNotifications}>
            <AdminNotificationsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: adminNotificationsRoutes.selfSettings,
    lazy: async () => {
      const { NotificationSettingsPage } = await import("./pages/settings/NotificationSettingsPage");

      return {
        element: (
          <RequireAuth permission={canEditOwnNotificationSettings}>
            <NotificationSettingsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: adminNotificationsRoutes.otherUserSettings,
    lazy: async () => {
      const { NotificationSettingsPage } = await import("./pages/settings/NotificationSettingsPage");

      return {
        element: (
          <RequireAuth permission={canEditOtherUserNotificationSettings}>
            <NotificationSettingsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
